<template>
  <transition name="confirm-fade">
    <div v-if="isShowConfirm" class="my-confirm">
      <div class="wrap ub ub-ac ub-pc ub-ver" :style="{ height: con_h, 'line-height': con_h }">
        <div class="manage ub ub-ac ub-pc" @click="manage()"><span>管理</span></div>
        <img id="img" :src="content" class="full-img" @click.stop="clickFun('clickCancel')"/>
      </div>
      <ryt-dropdown v-model="rytDropdown_manage" :actions="actions_manage" :center="rytDropdown_manage" @clickOption="chooseOption_manage" title="请选择" cancelText="关闭/取消" cancenTextColor="rgb(250,242,250)"></ryt-dropdown>
    </div>
    
  </transition>
</template>

<script>
import rytDropdown from "./Dropdown.vue";

export default {
  components: {
    rytDropdown,
  },
  data() {
    return {
      isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
      content: "pic_url", 
      id: "",// 内容框的内容
      i: {},
      con_h: "20em",
      rytDropdown_manage: false,
      actions_manage: {
          1: "删除",
          2: "置顶",
          3: "设为背景",
        },
    };
  },

  methods: {
    show(item) {
      this.item = item;
      this.content = item.url;
      this.id = item.id;
      this.isShowConfirm = true;

      //调整图片位置
      var h1 = window.innerHeight;
      this.con_h = h1 + "px";
    },
    hidden() {
      this.isShowConfirm = false;
      this.rytDropdown_manage = false;
      this.outerData = null;
    },
    clickFun(type) {
      this.hidden()
    },
    manage() {
        this.rytDropdown_manage = true;
    },
    chooseOption_manage(e) {
        if(e.item == "删除") {
            this.$emit('deleteImage',this.id);
            this.hidden()
        }
        if (e.item == "置顶") {
            this.$emit("topImage", this.item);
            this.hidden();
        }
        if (e.item == "设为背景") {
            this.$emit("bgImage",this.item)
        }
    }
  },
};
</script>

<style lang="scss" scoped>
.my-confirm {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 900;
  /* 这里防止当用户长按屏幕，出现的黑色背景色块，以及 iPhone 横平时字体的缩放问题 */
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

/* 进入和出去的动画 */
.confirm-fade-enter-active {
  animation: opacity 0.3s;
}

.confirm-fade-enter-active .wrap {
  animation: scale 0.3s;
}

.confirm-fade-leave-active {
  animation: outOpacity 0.2s;
}
/* 进来的动画 */
@keyframes opacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes scale {
  0% {
    transform: scale(0);
  }

  60% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

/* 出去的动画 */
@keyframes outOpacity {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

/* 包裹层容器样式 */
.wrap {
  position: absolute;
  top: 0;
  width: 100%;
  margin: 0 auto;
  user-select: none;
  text-align: center;
}

.manage {
  position: fixed;
  top: 0.5rem;
  right: 0.5rem;
  width: 4rem;
  height: 2rem;
  border-radius: 1rem;
  background: linear-gradient(90deg, #8a61ff 13%, #fe9cc0 91%);
  span {
    font-size: 0.9rem;
    font-weight: bold;
    color: #fff;
  }
}

.full-img {
  width: auto;
  max-width: 99%;
  max-height: 99%;
}

</style>